import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, Typography } from "@material-ui/core";
import { StyledLoadingCircularProgress, SupportText } from "./styled";
import { LoadingCircularProgressProps } from "./types";

const isCrolled = () => {
  const containerMain = document.querySelector(".container-main");
  // 125 é a altura do header
  return containerMain && containerMain.scrollTop > 125;
};

const LoadingCircularProgress = ({
  isLoading,
  percentual,
  fullHeight = false,
  fullHeightParent = false,
  supportText = undefined
}: LoadingCircularProgressProps) => {
  if (!isLoading) return null;

  return (
    <StyledLoadingCircularProgress
      fullHeight={isCrolled() ?? fullHeight}
      fullHeightParent={fullHeightParent}
      datatest-id="loading-circular-progress"
    >
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress size={80} thickness={4} variant="determinate" value={percentual} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 'bold',
            mx: 0.5,
            fontSize: 16
          }}
        >
          <Typography
            variant="inherit"
            component="div"
            style={{ color: "#3f51b5", padding: '4px', borderRadius: '2px' }}
          >
            {`${Math.trunc(percentual)}%`}
          </Typography>
        </Box>
      </Box>
      {supportText && supportText?.length > 0 &&
        <SupportText> {supportText} </SupportText>
      }
    </StyledLoadingCircularProgress>
  );
};

export default LoadingCircularProgress;
